import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-recruit',
  templateUrl: './recruit.component.html',
  styleUrls: ['./recruit.component.css']
})
export class RecruitComponent implements OnChanges{

  _subPage:string = '';

  private subscriptions = new Array();
  constructor(private route:ActivatedRoute,
    private cdr: ChangeDetectorRef) {
    this.subscriptions.push(this.route.params.subscribe(params=>{
      this.subPage = params.data;
      window.scrollTo(0,0);
    }));
  }

  ngOnChanges(changes: any): void{

  }

  set subPage(val) {
    this._subPage = val;
    setTimeout(() => {
      this.cdr.detectChanges();
    });
  }

  get subPage() {
    return this._subPage;
  }

 
  
  ngOnDestroy(){
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
